module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS41IDMwIj4KICAgIDxwYXRoIGQ9Ik0xMC43MTQgMzBDMy41NzEgMjEuMDg4IDAgMTQuNjYgMCAxMC43MTQgMCA0Ljc5NyA0Ljc5NyAwIDEwLjcxNCAwIDE2LjYzMiAwIDIxLjQzIDQuNzk3IDIxLjQzIDEwLjcxNGMwIDMuOTQ1LTMuNTcyIDEwLjM3NC0xMC43MTUgMTkuMjg2ek0xMSAxM2EzIDMgMCAxIDAgMC02IDMgMyAwIDAgMCAwIDZ6IgogICAgICAgICAgZmlsbD0iI0Y1NjIyNSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ui/NG_MAP_MARKER.svg
// module id = jcl4
// module chunks = 14